<template>
  <div>
    <div id="bar100p02" :style="[setHeight.height]">
      <svg
        :height="setHeight.height"
        version="1.1"
        width="100%"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        style="font-family:'IPA Pゴシック'; overflow: hidden; position: relative;"
      >
        <g class="scale">
          <line
            v-for="n of 11"
            class="scale-line"
            x1="7%"
            :y1="setMemoryY(n-1)"
            :x2="setMemoryX2"
            :y2="setMemoryY(n-1)"
            stroke="#eee"
            :key="`first-${n}`"
          />
          <text
            v-for="(item,num) in items"
            :x="setMemoryX"
            :y="setItemNameY(num)"
            font-size="10"
            stroke="black"
            text-anchor="start"
            stroke-width="0.5"
            :key="num"
          >
            <tspan>{{item.name}}</tspan>
            <tspan :x="setMemoryX" dy="15">{{item.name2}}</tspan>
            <tspan :x="setMemoryX" dy="15">{{item.name3}}</tspan>
          </text>
          <rect
            v-for="(val,num) in len"
            class="itemcolor"
            :x="setMemoryX"
            :y="setItemNameY(num)"
            :width="10"
            :height="10"
            :fill="setColor(num)"
            :key="`ic-${num}`"
          />
          <text
            v-for="n of 11"
            x="5"
            :y="setMemoryY(n-1)"
            font-size="8"
            stroke="black"
            text-anchor="start"
            stroke-width="0.5"
            :key="`sec-${n}`"
          >{{(n-1) *10}}%</text>
          <g>
            <text
              :x="setLabelX(1)"
              :y="setLabelY"
              font-size="8"
              stroke="black"
              text-anchor="middle"
              stroke-width="0.5"
            >全業界</text>
            <text
              :x="setLabelX(2)"
              :y="setLabelY"
              font-size="8"
              stroke="black"
              text-anchor="middle"
              stroke-width="0.5"
            >{{jobName}}</text>
          </g>
        </g>
        <g class="chart">
          <g class="bar">
            <rect
              v-for="(val,num) in len"
              class="bar-item"
              :x="graphLeft+'%'"
              :y="setGraphY(num,1)"
              :width="setGraphW"
              :height="setGraphH(val)"
              :fill="setColor(num)"
              :key="`bar1-${num}`"
            />
          </g>
          <g class="bar">
            <rect
              v-for="(val,num) in len2"
              class="bar-item"
              :x="setGraphX(2)"
              :y="setGraphY(num,2)"
              :width="setGraphW"
              :height="setGraphH(val)"
              :fill="setColor(num)"
              :key="`bar2-${num}`"
            />
          </g>
          <line
            v-for="(val,num) in len"
            class="bar-line"
            :x1="setBarLineX(1)"
            :y1="setBarLineY(num,1)"
            :x2="setBarLineX(2)"
            :y2="setBarLineY(num,2)"
            stroke="#777"
            :key="`barline-${num}`"
          />
          <!-- <animateTransform
            attributeName="transform"
            attributeType="XML"
            type="scale"
            begin="0s"
            dur="0.5s"
            repeatCount="0"
            values="1,0; 1,1"
          /> -->
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  props: ["graph2Data","jobName"],

  data() {
    return {
      barHeight: 300,
      topPadding: 50,
      bottomPadding: 50,
      graphLeft: 10,
      graphWidth: 20,
      graphDistance: 10,
      bgc: "#fff",
      //https://sample.atmarkit.jp/fux/1206/01/sample.xhtml 改行
      items: [
        { num: 1, name: "1秒たりとも", name2: "無駄にしない", name3: "行動重視営業" },
        { num: 2, name: "顧客との距離を縮める", name2: "信頼関係重視営業" },
        {
          num: 3,
          name: "戦略的に効率よく",
          name2: "アプローチする",
          name3: "KPI重視営業",
        },
        { num: 4, name: "話術で魅せる", name2: "提案方法重視営業" },
        { num: 5, name: "市場データを駆使する", name2: "提案内容重視営業" },
      ],
      len: [
        { num: 1, val: 7 },
        { num: 2, val: 33 },
        { num: 3, val: 19 },
        { num: 4, val: 21 },
        { num: 5, val: 20 },
      ],
      len2: this.graph2Data,

      colors: {
        1: "#fc7a22",
        2: "#e3e100",
        3: "#df4c8f",
        4: "#f0bd4e",
        5: "#eb4964",
      },
    };
  },
  computed: {
    setHeight() {
      return {
        height: this.barHeight + this.topPadding + this.bottomPadding,
      };
    },
    setMemoryY() {
      return function (data) {
        return this.barHeight - this.barHeight * (data / 10) + this.topPadding;
      };
    },
    setItemNameY() {
      return function (data) {
        return (
          this.barHeight - this.barHeight * (data / 5) + this.topPadding - 30
        );
      };
    },
    setGraphH() {
      return function (data) {
        return this.barHeight * (data.val / 100);
      };
    },
    setMemoryX2() {
      return (
        this.graphLeft + (this.graphWidth + this.graphDistance) * 2 - 5 + "%"
      );
    },
    setMemoryX() {
      return (
        this.graphLeft + (this.graphWidth + this.graphDistance) * 2 - 3 + "%"
      );
    },
    setGraphX() {
      return function (num) {
        let x;
        if (num === 2) {
          x = this.graphLeft + this.graphDistance + this.graphWidth;
        } else {
          x = this.graphLeft;
        }
        return x + "%";
      };
    },
    setGraphW() {
      return this.graphWidth + "%";
    },
    setGraphY() {
      return function (num, bar) {
        let leg = 0;
        let i = 0;
        if (bar === 1) {
          for (i = 0; i <= num; i++) {
            leg += this.len[i].val;
          }
        } else {
          for (i = 0; i <= num; i++) {
            leg += this.len2[i].val;
          }
        }
        return this.barHeight - this.barHeight * (leg / 100) + this.topPadding;
      };
    },
    setLabelX() {
      return function (val) {
        if (val == 2) {
          return (
            this.graphLeft +
            this.graphDistance +
            this.graphWidth +
            this.graphWidth / 2 +
            "%"
          );
        } else {
          return this.graphLeft + this.graphWidth / 2 + "%";
        }
      };
    },
    setLabelY() {
      return this.barHeight + this.topPadding + 15;
    },
    setColor() {
      return function (val) {
        return this.colors[val + 1];
      };
    },
    setBarLineX() {
      return function (bar) {
        let x;
        if (bar === 1) {
          x = this.graphLeft + this.graphWidth;
        } else {
          x = this.graphLeft + this.graphWidth + this.graphDistance;
        }
        return x + "%";
      };
    },
    setBarLineY() {
      return function (num, bar) {
        let leg = 0;
        let i = 0;
        if (bar === 1) {
          for (i = 0; i <= num; i++) {
            leg += this.len[i].val;
          }
        } else {
          for (i = 0; i <= num; i++) {
            leg += this.len2[i].val;
          }
        }
        return this.barHeight - this.barHeight * (leg / 100) + this.topPadding;
      };
    },
  },
};
</script>

<style lang="scss" scoped>
#bar100p02 {
  width: 100%;
  background-color: #fff;
  // max-width: 500px;
  box-sizing: border-box;
  padding: 0 5px;

  transform-origin: center bottom;
  animation: anim 0.5s linear 0s;
  animation-fill-mode: forwards;    

}
.chart {
  /* transform: scaleY(0.5); */
  transform-origin: 0 500px;
  // cursor: pointer;
}
// .bar-item:hover {
//   box-shadow: 1px 1px 1px 0 rgba(0, 0, 0, 0.5);
//   opacity: 0.5;
// }
.itemcolor {
  transform: translateX(-12px) translateY(-9px);
}
@keyframes anim {
  0%{
    transform: scaleY(0);
  }
  100%{
    transform: scaleY(1);
  }
}
</style>